import React from 'react';
import { Text } from 'react-native';

import TextSmall from './textSmall';
import Font from '../../config/Font';

export default ({ $bold, ...props }) => {
    const fontFamily = $bold ? Font.bold : Font.regular;

    return (
        <Text
            {...props}
            style={[props.style, fontFamily]}
            allowFontScaling={false}
        >
            {props.children}
        </Text>
    );
};

export { TextSmall };
